const Reports = {
  SearchReports: "Reports.SearchReports",
  NoSearchResultsTitle: "Reports.NoSearchResultsTitle",
  NoSearchResultsDescription: "Reports.NoSearchResultsDescription",
  Income: "Reports.Income",
  Costs: "Reports.Costs",
  Analysis: "Reports.Analysis",
  Documents: "Reports.Documents",
  Employees: "Reports.Employees",
  ArticlesDescription: "Reports.ArticlesDescription",
  InvoicesDescription: "Reports.InvoicesDescription",
  RecurringInvoicesDescription: "Reports.RecurringInvoicesDescription",
  IncomingInvoices: "Reports.IncomingInvoices",
  IncomingInvoicesDescription: "Reports.IncomingInvoicesDescription",
  Suppliers: "Reports.Suppliers",
  SuppliersDescription: "Reports.SuppliersDescription",
  Receipts: "Reports.Receipts",
  ReceiptsDescription: "Reports.ReceiptsDescription",
  Administration: "Reports.Administration",
  IncomeStatementDescription: "Reports.IncomeStatementDescription",
  CustomersDescription: "Reports.CustomersDescription",
  CustomerQuotesDescription: "Reports.CustomerQuotesDescription",
  SharedDocumentsDescription: "Reports.SharedDocumentsDescription",
  SIEFilesDescription: "Reports.SIEFilesDescription",
  TodoListDescription: "Reports.TodoListDescription",
  DocumentDraftsDescription: "Reports.DocumentDraftsDescription",
  CashReconciliationListDescription: "Reports.CashReconciliationListDescription",
  TimeReporting: "Reports.TimeReporting",
  BusinessUnitsDescription: "Reports.BusinessUnitsDescription",
  BalanceStatementDescription: "Reports.BalanceStatementDescription",
  CompanyBooksDescription: "Reports.CompanyBooksDescription",
  TimeReportingProjectsDescription: "Reports.TimeReportingProjectsDescription",
  Board: "Reports.Board",
  ListOfBoardMembersDescription: "Reports.ListOfBoardMembersDescription",
  AdvisoryView: "Reports.AdvisoryView",
  OwnerInformation: "Reports.OwnerInformation",
  DocumentationLog: "Reports.DocumentationLog",
  CompanyInformation: "Reports.CompanyInformation",
  ReconciledTo: "Reports.ReconciledTo",
  NoReconciliationDate: "Reports.NoReconciliationDate",
  RevisorView: "Reports.RevisorView",
  StateOfAnnualReport: "Reports.StateOfAnnualReport",
  AutomationReport: "Reports.AutomationReport",
  AutomationReportDescription: "Reports.AutomationReportDescription",
  ManageAssistants: "Reports.ManageAssistants",
  ManageAssistantsWithName: "Reports.ManageAssistantsWithName",
  ManageAssistantsWithNameAndCount: "Reports.ManageAssistantsWithNameAndCount",
  AssistantsSubtitle: "Reports.AssistantsSubtitle",
  AuditorAssistants: "Reports.AuditorAssistants",
  AssistantsSaved: "Reports.AssistantsSaved",
  AssistantsSaveFailed: "Reports.AssistantsSaveFailed",
  }
export default Reports;